'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var util = require('../../helper/util');


var LineChart = React.createClass({

  itemNum : 0,

  parseText: function() {

    var lines = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
    var result = [];
    var colors = [];

    for(var i=0;i<lines.length;i++) {
      var item = {
        points: undefined,
        color: 'rgba(0,0,0,1)'
      };
      var datas = lines[i].split(/,|，/);

      var colorStr = graphicsHelper.tranColor(datas[datas.length-1].trim());
      colors.push(colorStr);
      var off = 1;
      if(colorStr === "empty") {
        //colorStr = "ff000000";
        off = 0;
      }
      //item.color = graphicsHelper.toRGBA(colorStr);

      var points = [];
      if(datas.length-1-off > this.itemNum) {
        this.itemNum = datas.length - 1-off;
      }
      for(var j=0;j<datas.length-off;j++) {
        var n = 0;
        if(datas[j] === '-') {
          n = -1;
        }
        else if(parseFloat(datas[j])) {
          n = parseFloat(datas[j]);
          if(n > 100) {
            n = 100;
          }
          if(n < 0) {
            n = 0;
          }
        }
        points.push(n);
      }
      item.points = points;

      result.push(item);
    }
    graphicsHelper.getTempleteColor(colors);
    for(var i=0;i<result.length;i++) {
      result[i].color = graphicsHelper.toRGBA(colors[i]);
    }

    return result;
  },

  fillCanvas: function() {

    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var context = canvas.getContext('2d');
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var ratio = graphicsHelper.applyDeviceRatio(context,w,h);
    w *= ratio;
    h *= ratio;
    var width = Math.round(w * 0.9);
    var height = Math.round(h * 0.9);

    var offset = Math.round(h * 0.1);


    var result = this.parseText();
    context.lineWidth = ratio;
    for(var i=0;i<result.length;i++) {
      var item = result[i];
      var points = item.points;
      if(points.length > 0) {
        var itemWidth = Math.round(width / this.itemNum);
        context.beginPath();
        context.strokeStyle = item.color;
        var beginY = points[0];
        var beginX = 0;
        if(points[0] === -1 && points.length > 1) {
          beginX = itemWidth;
          beginY = points[1] ;
        }
        context.moveTo(beginX, Math.round(height-height*0.9*beginY/100+offset));
        for(var j=1;j<points.length;j++) {
          if(points[j] === -1) {
            continue;
          }
          context.lineTo(itemWidth*j, Math.round(height-height*0.9*points[j]/100+offset));
        }
        context.stroke();
      }

    }

  },

  componentDidMount: function () {
    this.fillCanvas();
  },

  componentDidUpdate: function () {
    this.fillCanvas();
  },


  render: function () {
    var style = styleHelper.StyleUtil(this.props).size().style;
    return (
      <div className="component-SimpleCom">
        <canvas ref="canvas" width={style.width} height={style.height}>
          浏览器不支持canvas
        </canvas>
        {
          this.props.axisvisible &&
          <div className="component-Chart-Coord"></div>
        }
      </div>
    )
  }
});

module.exports = LineChart;



// WEBPACK FOOTER //
// ./src/views/Components/LineChartEx.jsx